import proj4 from 'proj4';

export class CoordinatesTransformation {
    static wgs84ToLv95(longitude, latitude) {
        // WGS84 (Latitude/Longitude)
        const wgs84 = 'EPSG:4326';

        // LV95 (Swiss Coordinate System)
        const lv95 = 'EPSG:2056';

        // LV95 definition (source: https://spatialreference.org/ref/epsg/2056/proj4/)
        const lv95Definition =
            '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs';

        proj4.defs(lv95, lv95Definition);

        const [x, y] = proj4(proj4.defs(wgs84), proj4.defs(lv95), [
            longitude,
            latitude,
        ]);

        return [x, y];
    }
}
